export default __webpack_public_path__ + "static/media/submit.e46175b2.svg";